import styled, {css} from 'styled-components'
import Text from './Text'

export const cssVisuallyHidden = css`
  &:not(:focus):not(:active) {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`

const VisuallyHidden = styled(Text).attrs(({as = 'span'}) => ({
  as,
}))`
  ${cssVisuallyHidden}
`

export default VisuallyHidden
